




















import { vxm } from '../store.vuex';
import { Component, Vue } from 'vue-property-decorator';
import { RecruiterRequest } from '../models/referrals/recruiterrequest';
import { RecruiterResponse } from '../models/referrals/recruiterresponse';
import { ReferFriendRequest } from '../models/referrals/referfriendreqest';
import { ModelListSelect } from 'vue-search-select';
import { Recruiter } from '../models/referrals/recruiter';
import FormCard from './ReferAFriend/FormCard.vue';
import SectionContainer from './Commons/SectionContainer.vue';
import SectionTitle from './Commons/SectionTitle.vue';
import UserForm from './ReferAFriend/UserForm.vue';
import FormSection from './ReferAFriend/FormSection.vue';
import SubmitButton from './ReferAFriend/SubmitButton.vue';
import UserFormValidator from './ReferAFriend/userFormValidator';
import MailClientOpener from '@/components/ReferAFriend/mailClientOpener';
import { mixins } from 'vue-class-component';
import { InternalReferralFriendRequest } from '../models/referrals/internalReferralFriendRequest';
import { InternalReferralUserInfo } from '@/models/referrals/internalReferralUserInfo';
import { CommonUserInfo } from '../models/referrals/commonuserinfo';
import InternalRefUserForm from './ReferAFriend/InternalRefUserForm.vue';

@Component({
  name: 'AnonReferInternalFriend',
  components: {
    ModelListSelect,
    FormCard,
    SectionTitle,
    SectionContainer,
    UserForm,
    SubmitButton,
    FormSection,
    InternalRefUserForm,
  },
})
export default class AnonReferInternalFriend extends mixins(
  UserFormValidator,
  MailClientOpener,
) {
  private recruiterRequest: RecruiterRequest = new RecruiterRequest();
  private recruiterResponse: RecruiterResponse = new RecruiterResponse();
  private recruiter: Recruiter = new Recruiter();
  private commonUserInfo: CommonUserInfo = new CommonUserInfo();

  private referFriendRequest: InternalReferralFriendRequest = new InternalReferralFriendRequest();
  private friendInfo: InternalReferralUserInfo = new InternalReferralUserInfo();

  private errorString: string = '';
  private searchText: string = '';
  private successString: string = '';
  $wlToastr: any;
  private componentKey: number = 0;

  get getReferFriendTitle() {
    return vxm.configs.getGlobalConfigValue('INTERNAL_REFERRAL_ENABLED')
      ? this.$t('referinternalfriend.title')
      : this.$t('referafriend.title');
  }

  async sendAnonInternalReferFriendRequest() {
    let validationMessage;
    validationMessage = this.formValidator(this.friendInfo);
    if (validationMessage) {
      this.$wlToastr('error', validationMessage, 'Friend Info');
      return;
    }
    if(this.friendInfo.mobile==null && this.friendInfo.phoneNumber.length>0){
      this.friendInfo.phoneNumber = ''
    }
    validationMessage = this.formValidator(this.commonUserInfo);
    if (validationMessage) {
      this.$wlToastr('error', validationMessage, 'Your Info');
      return;
    }
    if(this.commonUserInfo.mobile==null && this.commonUserInfo.phoneNumber.length>0){
      this.commonUserInfo.phoneNumber = ''
    }
    if (
      this.friendInfo.email === this.commonUserInfo.email ||
     ((this.friendInfo.phoneNumber.length>0 &&  this.commonUserInfo.phoneNumber.length>0) && this.friendInfo.phoneNumber === this.commonUserInfo.phoneNumber)
    ) {
      this.$wlToastr('error', this.$t('quicksignup-details-same-referrer'), '');
      return;
    }

    this.referFriendRequest.commonUserInfo = this.commonUserInfo;
    this.referFriendRequest.friendList.push(this.friendInfo);
    this.referFriendRequest.companyCode =
      vxm.jobs.BrandingInfo.companycode || '';

    this.referFriendRequest.internalReferral = true;
    //hard coded to 04 as per api specification
    this.referFriendRequest.referralType = '04';

    delete this.referFriendRequest['sessionToken'];

    const respPromise: any = vxm.referrals.anonInternalReferTheFriend(
      this.referFriendRequest,
    );
    const resp = await respPromise;
    if (vxm.referrals.EmployeeReferralResponse.errorCode) {
      this.$wlToastr(
        'error',
        vxm.referrals.EmployeeReferralResponse.errorMessage,
        '',
      );
      this.friendInfo = new InternalReferralUserInfo();
      this.commonUserInfo = new CommonUserInfo();
      this.referFriendRequest = new InternalReferralFriendRequest();
      this.recruiter = new Recruiter();
      this.recruiterResponse = new RecruiterResponse();
    } else {
      this.$wlToastr(
        'success',
        vxm.referrals.EmployeeReferralResponse.successMessage,
        '',
      );
      this.mailClientOpener(this.friendInfo.email);
      this.friendInfo = new InternalReferralUserInfo();
      this.commonUserInfo = new CommonUserInfo();
      this.referFriendRequest = new InternalReferralFriendRequest();
      this.recruiter = new Recruiter();
      this.recruiterResponse = new RecruiterResponse();
      this.componentKey += 1;
    }
  }
}
